import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prospectus',
  templateUrl: './prospectus.component.html',
  styleUrls: ['./prospectus.component.scss']
})
export class ProspectusComponent implements OnInit {
  activeTab: '2026-27' | '2025-26' = '2026-27';

  constructor() { }
  ngOnInit(): void { }

  setActiveTab(tab: '2026-27' | '2025-26'): void {
    this.activeTab = tab;
  }
}
